import { render } from "./IconRestart.vue?vue&type=template&id=7b6bbd89&scoped=true&ts=true"
import script from "./IconRestart.vue?vue&type=script&lang=ts"
export * from "./IconRestart.vue?vue&type=script&lang=ts"

import "./IconRestart.vue?vue&type=style&index=0&id=7b6bbd89&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6bbd89"]])

export default __exports__